export default __webpack_public_path__ + "static/media/rose.d1dc7a2b.jpg";